import firebase from "firebase/app";
import "firebase/storage";

const deleteFileWithURL = (fileUrl: string) => {
    // Create a reference to the file to delete
    const deleteRef = firebase.storage().refFromURL(fileUrl);

    // Delete the file
    return deleteRef.delete();
};

export default deleteFileWithURL;
